import ConnectedHive from 'views/ConnectedHive'

const ConnectedHivePage = () => {
  return <ConnectedHive />
}

export default ConnectedHivePage
